import { Link } from 'react-router-dom'
import { SITE } from '../lib/site.js'
import { SERVICES } from '../lib/content.js'
import { Mark, Wordmark } from './Logo.jsx'
import { Container } from './ui.jsx'

const COMPANY = [
  { to: '/services', label: 'Services' },
  { to: '/results', label: 'Results' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
]

const colTitle = 'text-[12px] font-bold uppercase tracking-[0.14em] text-[#8b95a9]'
const colLink = 'text-[14px] text-[#c9d0dc] transition-colors hover:text-white'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer id="site-footer" className="bg-night text-white">
      <Container>
        <div className="grid gap-y-10 py-14 md:grid-cols-[1.4fr_1fr_1fr_1fr] md:gap-x-10">
          <div className="flex max-w-[360px] flex-col gap-y-4">
            <Link to="/" className="flex items-center gap-x-[10px]">
              <Mark className="h-9 w-9" />
              <Wordmark tone="white" />
            </Link>
            <p className="text-[14px] leading-[1.6] text-[#b6bfd0]">
              Marketing for the trades. Websites, local SEO, Google Ads, reviews and
              lead follow-up built for roofers, HVAC, plumbers, electricians and
              remodelers.
            </p>
            <p className="text-[13px] text-[#8b95a9]">{SITE.location}</p>
          </div>

          <div className="flex flex-col gap-y-3">
            <div className={colTitle}>Services</div>
            {SERVICES.map((s) => (
              <Link key={s.slug} to={`/services#${s.slug}`} className={colLink}>
                {s.title}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-y-3">
            <div className={colTitle}>Company</div>
            {COMPANY.map((item) => (
              <Link key={item.to} to={item.to} className={colLink}>
                {item.label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-y-3">
            <div className={colTitle}>Contact</div>
            <a href={SITE.phoneHref} className={colLink}>
              {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} className={colLink}>
              {SITE.email}
            </a>
            <span className="text-[14px] text-[#8b95a9]">{SITE.hours}</span>
          </div>
        </div>

        <div className="flex flex-col gap-y-3 border-t border-[rgba(255,255,255,0.1)] py-6 text-[13px] text-[#8b95a9] sm:flex-row sm:items-center sm:justify-between">
          <span>
            © {year} {SITE.name}. All rights reserved.
          </span>
          <span>Built for contractors. Judged on booked jobs.</span>
        </div>
      </Container>
    </footer>
  )
}
